module.exports = __webpack_public_path__ + "static/media/bold.8432a448.blob";